import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    // maxHeight: '94%',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
      label: '问卷标题',
      prop: 'title',
      search: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    // {
    //   label: '类型',
    //   prop: 'type',
    //   search: true,
    //   searchSlot: true,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: true,
    //   editDisabled: false,
    //   overHidden: true,
    //   align: 'center',
    //   formatter: function (row, value) {
    //     return value == 1 ? '单选' : value == 2 ? '多选' : value == 3 ? '文本框' : '暂无'
    //   }
    // },
    {
      label: "类型",
      prop: "type",
      search: true,
      type: "select",
      dicData: [
        {
          label: "单选",
          value: 1
        },
        {
          label: "多选",
          value: 2
        },
        {
          label: "文本框",
          value: 3
        }
      ],
      formatter: function (row, value) {
        if (Number(value) === 1) {
          return "单选";
        } else if (Number(value) === 2) {
          return "多选";
        } else if (Number(value) === 3) {
          return "文本框";
        }
        return "";
      }
    },
    // {
    //   label: '状态',
    //   prop: 'status',
    //   searchSlot: true,
    //   search: true,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: true,
    //   editDisabled: false,
    //   overHidden: true,
    //   align: 'center',
    //   formatter: function (row, value) {
    //     return value == 1 ? '启用' : value == 0 ? '禁用' : '未识别'
    //   }
    // },
    {
      label: "状态",
      prop: "status",
      search: true,
      type: "select",
      dicData: [
        {
          label: "启用",
          value: 1
        },
        {
          label: "禁用",
          value: 2
        }
      ],
      formatter: function (row, value) {
        if (Number(value) === 1) {
          return "启用";
        } else if (Number(value) === 2) {
          return "禁用";
        }
        return "";
      }
    },
    {
      label: '调查项内容',
      prop: 'optionStr',
      search: false,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '创建时间',
      prop: 'createTime',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      type: 'datetimerange',
      viewDisplay: false,
      align: 'right',
      hide: false,
      span: 24,
      formatter: function (row, value) {
        return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    }
    ]
  }
}